// istanbul ignore file
function getEvalVersion() {
	const linksWithHref = document.querySelectorAll('link[href]');
	if (!linksWithHref?.length) return '';

	const evalUrl = Array.from(linksWithHref).find(linkElement => {
		return linkElement?.href?.indexOf('hintsui-eval') !== -1;
	});

	if (!evalUrl) return '';
	const urlParts = evalUrl?.href?.split('/');
	urlParts?.pop();
	return urlParts?.pop() || '';
}

module.exports = getEvalVersion;
